import Content from "../../help/stock.mdx";

export function StockHelpPage() {
  return <Content />;
}
